import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { OutOptions } from '../../models/out-options.model';

@Component({
  selector: 'app-opt-out',
  templateUrl: './opt-out.component.html',
  styleUrls: ['./opt-out.component.scss']
})
export class OptOutComponent implements OnInit {
  @Input() public options: OutOptions;
  @Output() public optionsChanged: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public changedOptions() {
    this.optionsChanged.emit(this.options);
  }
}
